<template>
  <main
    class="app-container"
    :style="[
      !insideOfApp
        ? { backgroundImage: 'var(--homeBg)' }
        : { backgroundImage: 'var(--appBg)' },
    ]"
  >
    <TopNav v-if="insideOfApp" />
    <SideNav v-if="unit" />
    <section
      :class="[
        getFullWindowStyle,
        unit ? 'content' : 'page',
        { 'toggled-content': sidenavOpened },
      ]"
      ref="appView"
    >
      <router-view />
    </section>
  </main>
  <!-- this is will be state-managed on store -->
  <LoadingSpinner />
</template>

<script>
import TopNav from "./views/navigation/TopNav.vue";
import SideNav from "./views/navigation/SideNav.vue";
import { mapGetters } from "vuex";
import { version } from "../package.json";
import LoadingSpinner from "./components/utils/LoadingSpinner.vue";
export default {
  components: { TopNav, SideNav, LoadingSpinner },
  data() {
    return {
      hiddenTopnav: true,
      insideOfApp: null,
      appOutRouteNames: [
        "Home",
        "Login",
        "Register",
        "RecoverPassword",
        "NewPassword",
        "NotFound",
        "ServerError",
      ],
    };
  },
  async beforeCreate() {
    //reset modal to null state
    if (this.$store.state.scopeModal) {
      const scopeModal = { cmd: null, scope: null };
      this.$store.dispatch("scopeModal", scopeModal);
    }

    //reset loading state to false (prevention)
    if (this.$store.state.loading) {
      this.$store.dispatch("setLoading", false);
    }

    //check client side app version and reset if needed
    if (this.$store.state.clientVersion !== version) {
      await this.$router.push({ name: "Home" });
      this.$store.dispatch("logout");

      this.$store.dispatch("setClientVersion", version);
      console.log(this.$store.state.clientVersion);
    }
  },
  computed: {
    ...mapGetters("unitModule", ["unit"]),
    ...mapGetters(["sidenavOpened"]),
    getFullWindowStyle() {
      if (!this.$route.name) return;
      //Define valid routes for full-window-wrapper
      const validRouteNames = ["Auth", "ServerError"];

      //Get the current route name
      const validRoute = validRouteNames.find((routeName) => {
        return this.$route.matched[0].name.includes(routeName);
      });

      return {
        "full-window-wrapper": this.$route.matched[0].name === validRoute,
      };
    },
  },
  watch: {
    $route: {
      //This algorithm will dynamically change bg and show/hide topnav according to insideOfApp value
      //Compares the appOutRouteNames with the route current name and counter is used to update it
      //Somehow this is faster than .includes ????
      handler: function () {
        this.insideOfApp = null;

        let counter = 1;
        for (let i = 0; i < this.appOutRouteNames.length; i++) {
          if (counter === 0) break;
          if (this.$route.name === this.appOutRouteNames[i]) {
            counter--;
          }
        }
        counter > 0 ? (this.insideOfApp = true) : (this.insideOfApp = false);

        // this.insideOfApp = this.appOutRouteNames.includes(this.$route.name);
      },
    },
  },
};
</script>

<style>
#app {
  font-family: "Montserrat-Regular", "Inter-Black", Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--black3);
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
<style scoped>
.full-window-wrapper {
  height: 100%;
  top: 0;
}
</style>